/**
 * Run `callback` once the page has fully loaded.
 *
 * Runs synchronously if the `load` event has already fired, otherwise waits for
 * it. Used to defer non-critical video downloads (IV-1703) past initial load.
 *
 * @param {() => void} callback
 */
export default function afterPageLoad(callback) {
    if (document.readyState === 'complete') {
        callback()
        return
    }
    window.addEventListener('load', callback, { once: true })
}
